export const ALL_SOURCES = 'ALL_SOURCES';
export const ALL_FAMILIES = 'ALL_FAMILIES';
export const BLANK_FAMILY = '(Blank)';
